import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"


import TeamDriverAverageListQuery from "../reporting/getTeamDriverAverageList"
import addHistoricalDataToHeatmap from "../../../utils/heatmap/addHistoricalDataToHeatmap"


const HeatmapQuery = ({children, cycle, tenant, filters, context, ...props}) => {
  const {id: scheduleId, drivers: {results: drivers}, nthSurvey} = cycle
  const maxOpenedAt = get(nthSurvey, "openedAt")
  const {time: minOpenedAt} = filters
  const params = {cycleId: scheduleId, tenantUuid: tenant, minOpenedAt}
  const headerParams = {requests: drivers.map(({id: driverId}) => ({scheduleId, driverId, tenant, minOpenedAt}))}
  const historicalHeaderParams = {requests: drivers.map(({id: driverId}) => ({scheduleId, driverId, tenant, minOpenedAt, maxOpenedAt}))}
  const historicalProps = {
    variables: {params: {...params, maxOpenedAt}, headerParams: historicalHeaderParams},
    useLoader: false,
    context
  }

  return (
    <TeamDriverAverageListQuery
      {...props}
      context={context}
      params={params}
      historicalProps={historicalProps}
      headerParams={headerParams}>
      {({data: originalData = {}, historicalData = {}, ...apolloState}) => {
        const {data, headerData} = addHistoricalDataToHeatmap(originalData, historicalData)
        return children({data, headerData, ...apolloState})
      }}
    </TeamDriverAverageListQuery>
  )
}

HeatmapQuery.propTypes = {
  children: PropTypes.func.isRequired,
  cycle: PropTypes.object.isRequired,
  tenant: PropTypes.string,
  filters: PropTypes.object.isRequired,
  context: PropTypes.object
}
HeatmapQuery.defaultProps = {
  tenant: "",
  context: {}
}


export default HeatmapQuery
